export const ARTICLE_IMAGE_FALLBACK = '/placeholder.svg';

export const normalizeArticleImageUrl = (input: string): string => {
    const raw = (input || '').trim();
    if (!raw) {
        return ARTICLE_IMAGE_FALLBACK;
    }

    const normalized = raw
        .replace(/&amp;/g, '&')
        .replace(/^http:\/\//i, 'https://')
        .replace(/^\/\//, 'https://');

    if (/^\/(?:wp-content|wp-includes|uploads)\//i.test(normalized)) {
        return `https://cms.salamatlab.com${normalized}`;
    }

    if (/^https?:\/\//i.test(normalized) || /^data:/i.test(normalized)) {
        return normalized;
    }

    return ARTICLE_IMAGE_FALLBACK;
};
